import CreatableSelect from "react-select/creatable";
import React from "react";
import { SchoolOptions } from "./Options";

const SchoolSelect = ({ defaultValue, setSchool }) => {
  const handleIt = (event) => {
    setSchool(event.value);
  };
  const hasValue = defaultValue !== null && defaultValue !== undefined;

  return (
    <CreatableSelect
      defaultValue={hasValue ? { value: defaultValue, label: defaultValue } : null}
      onChange={(event) => handleIt(event)}
      options={SchoolOptions.sort((a, b) => (a.value < b.value ? -1 : 1))}
      placeholder="Current School"
      styles={{
        input: (baseStyles, state) => ({
          ...baseStyles,
          color: "rgb(226 232 240)",
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: "46px",
          minHeight: "46px",
          backgroundColor: "rgba(255, 255, 255, 0.06)",
          color: "rgb(226 232 240)",
          borderColor: state.isFocused
            ? "var(--accent-color-2)"
            : "rgba(255, 255, 255, 0.15)",
          borderRadius: "0.375rem",
          boxShadow: state.isFocused
            ? "0 0 0 2px rgba(108, 207, 246, 0.2)"
            : "none",
          ":hover": {
            borderColor: state.isFocused
              ? "var(--accent-color-2)"
              : "rgba(255, 255, 255, 0.15)",
          },
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          height: "46px",
          padding: "0 1rem",
        }),
        indicatorsContainer: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: "46px",
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          borderColor: "var(--accent-color-1)",
          backgroundColor: "rgb(51 65 85)",
          color: "rgb(226 232 240)",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          ":hover": { backgroundColor: "rgb(81 95 115)" },
          backgroundColor: "rgb(51 65 85)",
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          color: "rgb(226 232 240)",
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color: "rgb(100 116 139)",
        }),
      }}
    />
  );
};

export default SchoolSelect;
